import { makeAutoObservable, runInAction } from "mobx";
import { RootStore } from "./rootStore";

export default class AuthStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }
 
   showDefaultLogin: boolean = true;
   showAlternativeLogin: boolean = false;
   showRegister: boolean = false;
   showResetPwd: boolean = false;

   showLoginForm = () => {
    this.showDefaultLogin = true;
    this.showAlternativeLogin = false;
    this.showRegister = false;
    this.showResetPwd = false;
  };

   switchLogin = () => {
    runInAction(() => {
      this.showDefaultLogin = !this.showDefaultLogin;
      this.showAlternativeLogin = !this.showAlternativeLogin;
      this.showRegister = false;
      this.showResetPwd = false;
    });
  };

   showRegisterForm = () => {
    runInAction(() => {
      this.showDefaultLogin = false;
      this.showAlternativeLogin = false;
      this.showRegister = true;
      this.showResetPwd = false;
    });
  };

   showResetPwdForm = () => {
    runInAction(() => {
      this.showDefaultLogin = false;
      this.showAlternativeLogin = false;
      this.showRegister = false;
      this.showResetPwd = true;
    });
  };

 

    
}
